/* Swatches Linkify -> vrais liens <a> (SEO/GEO), zéro changement visuel/comportemental.
   - ne wrappe QUE les swatches disponibles. Linkify ne masque plus via style="display:none" :
     depuis 09/2026 linkify-plp-switch.js interroge la Storefront API à chaque chargement et pose
     data-plp-not-in-market sur les produits absents du marché. On lit ce marqueur.
     ATTENTION : data-plp-capped = produit VIVANT replié derrière "+N", il garde son lien.
   - un-wrap automatique si Linkify masque un swatch après coup (aucun lien vers produit archivé, quel que soit l'ordre d'exécution)
   - display:contents => le wrapper <a> ne génère aucune boîte, layout strictement identique
   - si Linkify change son markup, ce script ne fait rien (aucune casse) — surveillé par la routine SEO
   Lot SEO 3 — 08/2026, marqueur corrigé 09/2026 */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEL = 'linkify-product-colors-swatch[data-handle]';

  function isHidden(el) { return el.style.display === 'none' || el.hasAttribute('data-plp-not-in-market'); }

  function wrap(el) {
    if (isHidden(el) || el.closest('a')) return;
    var handle = el.getAttribute('data-handle');
    if (!handle) return;
    var a = document.createElement('a');
    a.href = root + 'products/' + handle;
    a.style.display = 'contents';
    a.className = 'swatch-crawlable-link';
    var label = el.getAttribute('aria-label');
    if (label) a.setAttribute('aria-label', label);
    el.parentNode.insertBefore(a, el);
    a.appendChild(el);
  }

  function unwrap(el) {
    var a = el.closest('a.swatch-crawlable-link');
    if (!a || !a.parentNode) return;
    a.parentNode.insertBefore(el, a);
    a.parentNode.removeChild(a);
  }

  function sync(el) { if (isHidden(el)) unwrap(el); else wrap(el); }

  function scan(ctx) {
    var els = (ctx || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) sync(els[i]);
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes' && m.target.matches && m.target.matches(SEL)) { sync(m.target); continue; }
      var nodes = m.addedNodes || [];
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(SEL)) sync(n);
        else if (n.querySelectorAll) scan(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-plp-not-in-market'] });
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });
})();
